import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from 'apollo-boost';
import config from '@/config';

// HTTP connection to the API
const httpLink = new HttpLink({
  uri: `${config().graphqlApiUrl}`,
  credentials: 'include',
})

const version = process.env.VUE_APP_VERSION

const authMiddleware = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'X-CSRF-TOKEN': localStorage.csrf,
      'Authorization': `Bearer ${localStorage.access}`,
      'apollographql-client-name': 'com.odeko.orderahead-admin.web',
      'apollographql-client-version': version,
    }
  }));
  return forward(operation);
});

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache,
})

export { apolloClient }
